import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, Phone, ShoppingBag, X } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { Logo } from "@/components/Logo";
import { useCart } from "@/context/CartContext";

const NAV = [
  { to: "/models", label: "Models" },
  { to: "/cars", label: "Cars" },
  { to: "/houses", label: "Houses" },
  { to: "/marketing", label: "Marketing" },
  { to: "/deals", label: "Deals" },
  { to: "/consultation", label: "Book a Consultation" },
];

export const SiteHeader = () => {
  const { items, setOpen } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Logo />
        <div className="flex items-center gap-3">
          <a data-testid="header-phone" href="tel:3234947199"
            className="hidden md:flex items-center gap-2 text-sm text-zinc-300 hover:text-white transition-colors">
            <Phone className="w-4 h-4 text-brand" /> 323-494-7199
          </a>
          <Link to="/consultation" data-testid="header-consultation-btn"
            className="hidden md:inline-flex bg-brand hover:bg-brand-hover text-white text-xs font-semibold tracking-widest uppercase px-5 py-2.5 transition-colors">
            Book a Consultation
          </Link>
          <button data-testid="cart-open-btn" onClick={() => setOpen(true)}
            className="relative p-2 text-zinc-300 hover:text-white transition-colors" aria-label="Cart">
            <ShoppingBag className="w-5 h-5" />
            {items.length > 0 && (
              <span data-testid="cart-count"
                className="absolute -top-0.5 -right-0.5 bg-brand text-white text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center">
                {items.length}
              </span>
            )}
          </button>
          <Sheet open={menuOpen} onOpenChange={setMenuOpen}>
            <SheetTrigger asChild>
              <button data-testid="menu-open-btn" className="p-2 text-zinc-300 hover:text-white transition-colors" aria-label="Menu">
                <Menu className="w-6 h-6" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-[#0A0A0A] border-white/10 w-80 p-0">
              <SheetTitle className="sr-only">Menu</SheetTitle>
              <div className="p-6 border-b border-white/10 flex items-center justify-between">
                <Logo compact />
                <button data-testid="menu-close-btn" onClick={() => setMenuOpen(false)} className="text-zinc-400 hover:text-white" aria-label="Close menu">
                  <X className="w-5 h-5" />
                </button>
              </div>
              <nav className="p-6 flex flex-col gap-1">
                {NAV.map((n) => (
                  <Link key={n.to} to={n.to} data-testid={`menu-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                    onClick={() => setMenuOpen(false)}
                    className="font-display text-3xl text-zinc-300 hover:text-brand py-2 transition-colors">
                    {n.label}
                  </Link>
                ))}
              </nav>
              <div className="p-6 mt-auto border-t border-white/10">
                <a href="tel:3234947199" data-testid="menu-phone"
                  className="flex items-center gap-2 text-zinc-300 hover:text-brand transition-colors">
                  <Phone className="w-4 h-4 text-brand" /> 323-494-7199
                </a>
                <p className="text-xs text-zinc-500 mt-3">Los Angeles, CA</p>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
